export const EVENT_TYPES = [
  "Dr. Visit",
  "Family Visit",
  "Reminder",
  "Appointment",
  "Activity",
  "Menu",
  "Birthday",
  "CPR/FA",
  "New Hire Orientation",
  "Med Certification",
  "Safety Care",
  "Admin Meeting",
  "Program Manager Meeting",
  "House Manager Meeting",
  "Maintenance",
  "Other"
];

export const CLIENT_EVENTS = [
  "Activity",
  "Appointment",
  "Birthday",
  "Dr. Visit",
  "Family Visit",
  "Meeting",
  "Menu",
  "Other",
  "Reminder",
  "Vocational Rehabilitation",
  "Maintenance",
  "Work"
];

export const STAFF_EVENTS = [
  "Team Meeting",
  "Program Meeting",
  "Birthday",
  "CPR/FA",
  "New Hire Orientation",
  "Med Certification",
  "Safety Care",
  "Admin Meeting",
  "Program Manager Meeting",
  "Maintenance",
  "House Manager Meeting"
];

export const VISIT_TYPES = [
  "Admitting Physician",
  "Allergist",
  "Appointed Attorney",
  "Attending Physician",
  "Audiologist",
  "Behaviorist",
  "Cardiologist",
  "Care Worker Supervisor",
  "Case Worker",
  "Chiropractor",
  "Counselor/Therapist",
  "Dentist",
  "Dermatologist",
  "Ears, Nose and Throat (ENT)",
  "Emergency Room",
  "Employer",
  "Endocrinologist",
  "Gastroenterologist",
  "Gynecologist",
  "Hospital",
  "Lab",
  "Legal Guardian",
  "Nephrologist",
  "Neurologist",
  "Nurse",
  "Nurse Practitioner",
  "Nutritionist/Dietician",
  "Occupational Therapist",
  "Optometrist/Ophthalmologist",
  "Orthopedic",
  "Parent (Connect Access)",
  "Pharmacy",
  "Phlebotomist",
  "Physical Therapist",
  "Physician or Specialist",
  "Physician Assistant",
  "Podiatrist",
  "Primary Care MD",
  "Psychiatrist",
  "Public Guardian",
  "Radiologist",
  "Sleep Specialist",
  "Support Coordinator",
  "Surgeon",
  "Urologist",
  "Urgent Care",
  "Work Site",
  "Wound Care"
];

export const EVENT_FOR = ["Staff", "Client"];

export const RECURRING_OPTIONS = ["Daily", "Weekly", "Monthly", "Annually"];

export const TRANSPORTATION_OPTIONS = ["Yes", "No"];
